<template>
    <footer class="footer" style="padding: 0px; background: none">
        <div class="container">
            <div class="row row-grid align-items-center" style="color: white; margin: 15px">
                <div class="col-lg-6 text-lg-center btn-wrapper">
                    <a href="https://www.facebook.com/delajuventud" target="_blank" rel="noopener noreferrer">
                    <img src="/img/custom/facebook_icon.svg" style="width: 40px;" alt="Facebook">
                    </a>
                    <h4 style="color: white; font-family: Quicksand">Suscríbete</h4>
                    <p><input type="text"></p>
                </div>
                
                <div class="col-lg-6 text-lg-center btn-wrapper">
                    <img src="/img/brand/logo_medellin_joven.png" style="max-width: 115px;" alt="Medellín Joven">
                    <img src="/img/brand/logo-alcaldia.svg" style="max-width: 115px;" alt="Alcaldía de Medellín">
                </div>
                <div class="col-lg-12 text-lg-center btn-wrapper">
                    <p><b><span style="color: white;"><b>Contáctanos: </b></span>
                    <i class="ni ni-mobile-button"></i> Teléfono 4444144 - <i class="ni ni-square-pin"></i> Dirección Carrera 53A # 42 - 161. Edificio Plaza de la Libertad. Torre A. Piso 10. - <i class="ni ni-email-83"></i> masvivos@medellinjoven.com</b></p>
                </div>
                <hr style="width: 100%; background: rgba(255, 255, 255, 0.14); margin: 1rem">
                <div class="col-lg-12 text-lg-center btn-wrapper footer-links">
                     <a href="https://www.medellinjoven.com/politicas/declaracion-de-derechos-y-responsabilidades">Declaración de derechos y responsabilidades</a> 
                     <a href="https://www.medellinjoven.com/politicas/politica-de-datos">Política de datos</a> 
                     <a href="https://www.medellinjoven.com/politicas/politica-de-cookies">Política de cookies</a> 
                </div>
            </div>
            <!-- <hr>
            <div class="row align-items-center justify-content-md-between">
                <div class="col-md-6">
                    <div class="copyright">
                        &copy; {{year}}
                        <a href="https://www.creative-tim.com" target="_blank" rel="noopener">Creative Tim</a> & <a href="https://www.binarcode.com" target="_blank" rel="noopener">Binar Code</a>
                    </div>
                </div>
            </div> -->
        </div>
    </footer>
</template>
<script>
export default {
  name: 'app-footer',
  data() {
    return {
      year: new Date().getFullYear()
    }
  }
};
</script>
<style>
.footer-links a{
    margin: 15px
}

@font-face {
    font-family: 'Quicksand';
    font-style: bold;
    font-weight: 700;
    src: local('Raleway'), local('Raleway-Regular'), url("/fonts/Quicksand-Bold.otf") format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2212, U+2215, U+E0FF, U+EFFD, U+F000;
}

@font-face {
    font-family: 'Quicksand';
    font-style: normal;
    font-weight: 400;
    src: local('Raleway Italic'), local('Raleway-Italic'), url("/fonts/Quicksand-Regular.otf") format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2212, U+2215, U+E0FF, U+EFFD, U+F000;
}

@font-face {
    font-family: 'Quicksand';
    font-weight: 300;
    src: local('Raleway Italic'), local('Raleway-Italic'), url("/fonts/Quicksand-Light.otf") format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2212, U+2215, U+E0FF, U+EFFD, U+F000;
}
</style>
